import IdeationIcon from './IdeationIcon'

export default IdeationIcon
